import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'kuebler',
} as IModuleProps;
